import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import Wrapper from '../wrapper/'
import { ButtonEdit } from '../app-button/button'
import style from './SiteBox.style'

class SiteBox extends Component {
  handleBack = () => {
    location.href = this.props.prevUrl
  }

  render() {
    const { classes, url, resource, gutterBottom, icon } = this.props

    return (
      <Wrapper shadow={1}>
        <a
          className={classes.container}
          style={{ marginBottom: gutterBottom }}
          href={`http://${url.replace(/(http|https):\/\//is, '')}`}
          target="_blank"
        >
          {icon ? icon : <div className={classes.siteIcon}>S</div>}
          <ul className={classes.info}>
            <Typography component="li" variant="body1">
              {url}
            </Typography>
            <Typography component="li" variant="overline">
              {resource}
            </Typography>
          </ul>
          <ButtonEdit handleClick={this.handleBack} />
        </a>
      </Wrapper>
    )
  }
}

export default style(SiteBox)
